import { Link } from 'react-router-dom'
import { Section, SectionHeading } from '../components/ui'

export default function NotFound() {
  return (
    <Section tone="panel" hero>
      <SectionHeading
        eyebrow="Page not found"
        title="We couldn't find that page."
        lede="The page you're looking for may have moved. Head back home or give us a call — we're happy to help."
      />
      <div style={{ marginTop: 32 }}>
        <Link to="/" className="btn btn-primary">Back to Home</Link>
      </div>
    </Section>
  )
}
